"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacySingleSelectListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var BubbleHoverTrigger_1 = require("../Bubble/BubbleHoverTrigger");
var Bubble_1 = require("../Bubble/Bubble");
var BUBBLE_OFFSET_X = 16;
/**
 * @internal
 * @deprecated This component is deprecated use SingleSelectListItem instead
 */
var LegacySingleSelectListItem = /** @class */ (function (_super) {
    tslib_1.__extends(LegacySingleSelectListItem, _super);
    function LegacySingleSelectListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isOverflowed: false };
        _this.node = null;
        _this.handleSelect = function () {
            _this.props.onSelect(_this.props.source);
        };
        _this.handleMouseOver = function () {
            _this.props.onMouseOver(_this.props.source);
        };
        _this.handleMouseOut = function () {
            _this.props.onMouseOut(_this.props.source);
        };
        return _this;
    }
    LegacySingleSelectListItem.prototype.componentDidMount = function () {
        this.checkOverflow();
    };
    LegacySingleSelectListItem.prototype.componentDidUpdate = function () {
        this.checkOverflow();
    };
    LegacySingleSelectListItem.prototype.getClassNames = function () {
        var _a = this.props, source = _a.source, selected = _a.selected;
        var generatedSeleniumClass = "s-" + util_1.stringUtils.simplifyText(source.title);
        return classnames_1.default("gd-list-item", generatedSeleniumClass, { "is-selected": selected });
    };
    LegacySingleSelectListItem.prototype.checkOverflow = function () {
        if (this.node) {
            // Checks if ellipsis has been applicated on title span
            var isOverflowed = this.node.offsetWidth < this.node.scrollWidth;
            if (isOverflowed !== this.state.isOverflowed) {
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isOverflowed: isOverflowed,
                });
            }
        }
    };
    LegacySingleSelectListItem.prototype.renderTitle = function () {
        var _this = this;
        var title = this.props.source.title;
        var titleElement = (react_1.default.createElement("span", { ref: function (node) {
                _this.node = node;
            } }, title));
        if (this.state.isOverflowed) {
            return (react_1.default.createElement(BubbleHoverTrigger_1.BubbleHoverTrigger, null,
                titleElement,
                react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "cr cl" }, { align: "cl cr" }], arrowOffsets: {
                        "cr cl": [BUBBLE_OFFSET_X, 0],
                        "cl cr": [-BUBBLE_OFFSET_X, 0],
                    } }, title)));
        }
        return titleElement;
    };
    LegacySingleSelectListItem.prototype.renderIcon = function (icon) {
        if (icon) {
            var iconClasses = classnames_1.default("gd-list-icon", icon);
            return react_1.default.createElement("span", { className: iconClasses });
        }
        return null;
    };
    LegacySingleSelectListItem.prototype.render = function () {
        var _a;
        var icon = (_a = this.props.source) === null || _a === void 0 ? void 0 : _a.icon;
        return (react_1.default.createElement("div", { className: this.getClassNames(), onClick: this.handleSelect, onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut },
            this.renderIcon(icon),
            this.renderTitle()));
    };
    LegacySingleSelectListItem.defaultProps = {
        onMouseOver: noop_1.default,
        onMouseOut: noop_1.default,
    };
    return LegacySingleSelectListItem;
}(react_1.Component));
exports.LegacySingleSelectListItem = LegacySingleSelectListItem;
//# sourceMappingURL=LegacySingleSelectListItem.js.map